// Menu powiązanych kolekcji (sections/collection-menu.liquid): wszystkie menu zwinięte razem do wysokości z CSS,
// przycisk "Rozwiń" tylko wtedy, gdy coś się nie mieści (zależy od szerokości ekranu, więc liczymy przy każdej zmianie).
class CollectionMenus extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('.collection-menus__content');
    this.button = this.querySelector('.collection-menus__toggle');

    this.button.addEventListener('click', this.onToggleClick.bind(this));
    new ResizeObserver(this.update.bind(this)).observe(this.querySelector('.collection-menus__inner'));
  }

  isOpen() {
    return this.button.getAttribute('aria-expanded') === 'true';
  }

  update() {
    if (this.isOpen()) {
      this.content.style.maxHeight = `${this.content.scrollHeight}px`;
      return;
    }

    const fits = this.content.scrollHeight <= this.content.clientHeight;
    this.classList.toggle('collection-menus--fits', fits);
    this.button.hidden = fits;
  }

  onToggleClick() {
    const open = !this.isOpen();

    this.button.setAttribute('aria-expanded', open);
    this.classList.toggle('collection-menus--open', open);
    // przejście max-height działa tylko na konkretnej wartości, więc przy rozwijaniu ustawiamy pełną wysokość
    this.content.style.maxHeight = open ? `${this.content.scrollHeight}px` : '';
  }
}

customElements.define('collection-menus', CollectionMenus);
